import _ from 'underscore'

export function update(state = {}, data = {}) {
  return _.isEqual(state,data) ? state : data
}

export function handleUpdate(_url, state={}, action) {
  let {type, url, data} = action
  if(type !== 'value' || _url !== url) return state
  return update(state,data)
}

function updateChild(state,child,key){
  let id = child.id || key
  if(child.isDeleted) {
    delete state[id]
  } else {
    state[id] = child
  }
  return state
}

export function handleWatch(_url, state={}, {url,type,data,key}) {
  if(_url !== url || !data) return state

  switch(type) {
    case 'logout':
      return {}

    case 'value':
      if(data instanceof Array) {
        let obj = {}
        data.forEach((value,index)=>{
          if(value) {
            obj[index+''] = value
          }
        })
        // console.log(_url,'is Array',obj)
        return update(state,obj)
      } else {
        return update(state,data)
      }
    case 'child_added':
    case 'child_changed':
      state = {...state}
      return updateChild(state,data,key)

    case 'child_removed':
      state = {...state}
      delete state[data.id]
      return state

    default:
      return state
  }

}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/common.js
 **/